import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ESGSurveyView from '../views/ESGSurveyView.vue'
import ResponsepageView from '../views/ResponsepageView.vue'
import LogoutView from '../views/LogoutView.vue'
//import { Message } from 'element-ui'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    //meta: { requireAuth: true }, // 用來作為此頁是否需要權限驗證的設定
    component: HomeView
  },  
  {
    path: '/home',
    name: 'home',
    //meta: { requireAuth: true }, // 用來作為此頁是否需要權限驗證的設定
    component: HomeView
  },
  {
    path: '/ESGSurvey',
    name: 'ESGSurvey',
    //meta: { requireAuth: true }, // 用來作為此頁是否需要權限驗證的設定
    component: ESGSurveyView
  },
  {
    path: '/Responsepage',
    name: 'Responsepage',
    //meta: { requireAuth: true }, // 用來作為此頁是否需要權限驗證的設定
    component: ResponsepageView
  },
  {
    path: '/Logout',
    name: 'Logout',
    meta: { requireAuth: true }, // 用來作為此頁是否需要權限驗證的設定
    component: LogoutView
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
//import { authToken } from '@/api/login'
/*router.beforeEach(async(to, from, next) => {
  // 看看 to 和 from 決定路由
 // console.log('to: ', to);console.log('from: ', from);
  const isLogin = window.localStorage.getItem("isLogin");
  const username = window.localStorage.getItem("username");
  // 目的路由在meta上是否有設置requireAuth: true
  if (to.meta.requireAuth) {
    if(!isLogin) {
      next({ name: 'login' });
    }
    const authResult = await authToken();
    if(!authResult.status){
      next({ name: 'login' });
    }else{
      next();
    }
  } else {
    if(to.name == 'login' && isLogin){      
      const authResult = await authToken();
      if(!authResult.status){
        console.log("77777777");
        Message({
          message: "閒置時間太長，請重新登入..",
          type: 'error',
          duration: 1000
        });
        next({ name: 'login' });
      }else{
        Message({
          message: username+'已登入',
          type: 'success',
          duration: 1000
        });
        next({ name: 'home' });
      }
    }
    next()
  }
})*/
export default router
